// Wishlist functionality
function toggleWishlist(btn) {
  const productId = btn.dataset.productId;
  let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  if (wishlist.includes(productId)) {
    wishlist = wishlist.filter(id => id !== productId);
    btn.classList.remove('active');
  } else {
    wishlist.push(productId);
    btn.classList.add('active');
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));
}

// On page load, restore wishlist state
document.addEventListener('DOMContentLoaded', function() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  document.querySelectorAll('.wishlist-btn').forEach(btn => {
    if (wishlist.includes(btn.dataset.productId)) {
      btn.classList.add('active');
    }
  });
});